module.exports = __webpack_public_path__ + "startpage-746fed5a/feedback-197cedee9db8213138f8094043dfb7c1.jpeg";